<template>
  <div>
    <v-contextmenu ref="contextmenuTelNet">
      <v-contextmenu-item @click="handelDetail">详情</v-contextmenu-item>
      <v-contextmenu-item
        @click="connectTelnet"
        v-show="contextMenu.Type==2||contextMenu.Type==3"
      >Telnet远程</v-contextmenu-item>
      <v-contextmenu-item
        @click="connectSSH"
        v-show="contextMenu.Type==2||contextMenu.Type==3"
      >SSH远程</v-contextmenu-item>
      <v-contextmenu-item @click="handleRemoteClick" v-show="contextMenu.Type==1">远程控制</v-contextmenu-item>
    </v-contextmenu>
    <el-dialog title="请输入Telnet信息" :visible.sync="TelnetVisible" width="30%" append-to-body center>
      <el-form ref="form" label-width="50px">
        <el-form-item label="MgIp">
          <el-input v-model="MgIp"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TelnetVisible = false">取 消</el-button>
        <el-button type="primary" @click="telnet(MgIp)">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请输入SSH信息" :visible.sync="SSHVisible" width="30%" append-to-body center>
      <el-form ref="form" label-width="90px">
        <el-form-item label="MgIp">
          <el-input v-model="MgIp"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="USERNAME"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="SPASSWORD"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SSHVisible = false">取 消</el-button>
        <el-button type="primary" @click="SSH(MgIp, USERNAME, SPASSWORD)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { GetSSHLinkInfoById } from "@/api/modules/basicData/task";
import { getMac } from "@/api/modules/basicData/clientApi";
export default {
  props: {
    contextMenu: {
      type: Object,
      default: () => {},
      require: true,
    },
    props: {
      isTask: {
        type: Boolean,
        default: true,
      },
    },
  },
  data() {
    return {
      TelnetVisible: false,
      MgIp: "",
      USERNAME: "",
      SPASSWORD: "",
      SSHVisible: false,
    };
  },
  methods: {
    Show(postition) {
      //显示右键菜单
      console.log(postition)
      this.$refs.contextmenuTelNet.show(postition);
    },
    /**
     * 查看详情
     */
    handelDetail() {
      let row = this.contextMenu;
      let str = JSON.stringify(row);
      const { href } = this.$router.resolve({
        name: "objectDetail",
        query: {
          objBasicInfo: str,
        },
      });
      window.open(href, "_blank");
    },
    // 连接telnet
    connectTelnet() {
      let deviceItem = this.contextMenu;
      console.log("触发telnet", deviceItem);
      if (!deviceItem.MgIp) {
        this.TelnetVisible = true;
      } else {
        this.telnet(deviceItem.MgIp);
      }
    },
    telnet(device) {
      //操作函数
      this.TelnetVisible = false;
      this.MgIp = "";
      if (!device) {
        this.$message({
          message: "MgIp不存在",
          type: "warning",
        });
        return;
      }
      let pathUrl = this.stringFormat("RedCoral://Telnet/?{0}", [device]);
      console.log(pathUrl);
      var iframeObj = $("#startProgram");
      if (iframeObj.length < 1) {
        $("body").append(
          '<iframe id="startProgram" src="' +
            pathUrl +
            '" style="display:none;"></iframe>'
        );
      } else {
        $("#startProgram").attr("src", pathUrl);
      }
      window.protocolCheck(pathUrl, (res) => {
        this.$message({
          showClose: true,
          message: "未安装运维管理软件,请下载安装",
          type: "warning",
        });
      });
      this.$emit("telnet", device);
    },
    // 连接connectSSH
    connectSSH() {
      let deviceItem = this.contextMenu;
      GetSSHLinkInfoById(deviceItem.SocialId).then((obj) => {
        this.MgIp = deviceItem.MgIp;
        this.USERNAME = obj ? obj.USERNAME : "";
        this.SPASSWORD = obj ? obj.SPASSWORD : "";
        if (!this.MgIp || !this.USERNAME || !this.SPASSWORD) {
          this.SSHVisible = true;
        } else {
          this.SSH(deviceItem.MgIp, this.USERNAME, this.SPASSWORD);
        }
      });
      //RedCoral://SSH/?Ip=10.64.3.176&username=test&password=wlzx2283
    },

    SSH(device, userName, password) {
      this.SSHVisible = false;
      this.MgIp = "";
      this.SPASSWORD = "";
      this.USERNAME = "";
      if (!device || !userName || !password) {
        this.$message({
          message: "数据不存在",
          type: "warning",
        });
        return;
      }
      let pathUrl = this.stringFormat(
        "RedCoral://SSH/?Ip={0}&username={1}&password={2}",
        [device, userName, password]
      );
      console.log(pathUrl);
      var iframeObj = $("#startProgram");
      if (iframeObj.length < 1) {
        $("body").append(
          '<iframe id="startProgram" src="' +
            pathUrl +
            '" style="display:none;"></iframe>'
        );
      } else {
        $("#startProgram").attr("src", pathUrl);
      }
      window.protocolCheck(pathUrl, (res) => {
        console.log("SSH", res);
        this.$message({
          showClose: true,
          message: "未安装运维管理软件,请下载安装",
          type: "warning",
        });
      });
      this.$emit("SSH", device);
    },
    //远程控制
    handleRemoteClick() {
      let rowData = this.contextMenu;
      //远程连接
      getMac(rowData.MAC).then((res) => {
        if (res && res.ONLINE == 1) {
          let Ip = res.IP + ":" + res.VNCPORT;
          let Mac = res.MAC;
          let PId = 0;
          let sysUser = res.SYSTEMUSERNAME == null ? "" : res.SYSTEMUSERNAME;
          let pws = res.VNCPASSWORD == null ? "" : res.VNCPASSWORD;
          remote(Ip, Mac, PId, sysUser, pws);
        } else {
          this.$message.warning("当前客户机已离线");
        }
      });
      //				let pathUrl = this.stringFormat(
      //					"RedCoral://Remote/?Ip={0}&Mac={1}&PId={2}", [rowData.IP, rowData.MAC, 1]
      //				);
      //				var iframeObj = $("#startProgram");
      //				if(iframeObj.length < 1) {
      //					$("body").append(
      //						'<iframe id="startProgram" src="' +
      //						pathUrl +
      //						'" style="display:none;"></iframe>'
      //					);
      //				} else {
      //					$("#startProgram").attr("src", pathUrl);
      //				}
      //				window.protocolCheck(pathUrl, (res) => {
      //					console.log("remote", res);
      //					this.$message({
      //						showClose: true,
      //						message: "未安装运维管理软件,请下载安装",
      //						type: "warning"
      //					});
      //				});
      //				this.$emit("remoteClick", rowData);
    },
  },
};
</script>